export const prettifiedLabel = (string) => {
  if (string) {
    return (
      string.charAt(0).toUpperCase() +
      string
        .slice(1)
        .replace(/([A-Z])/g, ' $1')
        .trim()
    );
  }
};

export default prettifiedLabel;
